// export const API_BASE_URL = '/home/api'; //  
// 
// export const API_BASE_URL = window.location.origin + "/home/api";
export const API_BASE_URL = 
        'https://emasajid.moia.gov.sa';
    //   'https://localhost:7066';
    // 'http://172.20.21.169:8083';
    // 'http://172.20.21.169:8080';    
      // 'http://172.20.21.169:8089'; 
     // 'https://emasajid.moia.gov.sa';
     // 'http://172.20.10.77:8080'; 
     // 'http://172.20.10.90:8080'; //  Staging
      //  'http://172.20.10.90:8090'; // UAT 

export const RECAPTCHA_SITE_KEY = '6LdZA5IrAAAAALPwG6x0v9xtEP0XVfuNh9VZt1Qt';
export const GOOGLE_MAPS_API_KEY = "AIzaSyCjil-HECi1UM4bNY6l8Yoyuoqa-YtQUbk";



/** NEW: Base URL for your PHP/WordPress site (no trailing slash) */
export const WORDPRESS_BASE_URL = 'http://localhost/wordpress/';

// === NEW: Tiny config for the WP↔React bridge ===
export const AUTH_BRIDGE = {
  /** Exact parent origin the iFrame is allowed to talk to */
  parentOrigin: WORDPRESS_BASE_URL,

  /** CustomEvent your auth code will dispatch on login/logout/refresh */
  authChangedEventName: 'auth:state-changed',

  /** Optional: iFrame-side sessionStorage key for a tiny snapshot (no tokens) */
  sessionStorageKey: 'emasajid.authSnapshot',
};

/** NEW: Utility to detect embed mode (we only mount the bridge when true) */
export const isEmbedMode = (search = window.location.search) => {
  try {
    return new URLSearchParams(search).get('embed') === '1';
  } catch {
    return false;
  }
};

// Chatbot settings live in their own file so they are easy to enable or disable independently.
export { CHATBOT_CONFIG } from './chatbot';
